import { DRAFT_KEY, EMPTY_FORM } from "./kusurConstants";

export function loadDraft() {
    try {
        const raw = localStorage.getItem(DRAFT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function saveDraft(data) {
    try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    } catch {
        /* ignore */
    }
}

export function applyFormFields(prev, data) {
    const f = data?.form || data || {};
    const pick = (key, preferLonger = false) => {
        const nv = f[key];
        const pv = prev[key];
        if (nv == null || nv === "") return pv;
        if (preferLonger && pv && String(pv).length > String(nv).length + 20) return pv;
        return nv;
    };
    return {
        ...prev,
        sigorta_dosyasi_id: String(f.sigorta_dosyasi_id || prev.sigorta_dosyasi_id || ""),
        baslik: pick("baslik") || prev.baslik,
        plaka_a: pick("plaka_a"),
        plaka_b: pick("plaka_b"),
        taraf_a_adi: pick("taraf_a_adi"),
        taraf_b_adi: pick("taraf_b_adi"),
        kaza_tarihi: (pick("kaza_tarihi") || "").slice(0, 10) || prev.kaza_tarihi,
        kaza_yeri: pick("kaza_yeri"),
        olay_ozeti: pick("olay_ozeti", true),
        beyan_metni: pick("beyan_metni", true),
        mevcut_kusur_orani:
            f.mevcut_kusur_orani != null && f.mevcut_kusur_orani !== ""
                ? String(f.mevcut_kusur_orani)
                : prev.mevcut_kusur_orani,
    };
}

export function applyFormFromApi(prev, r) {
    const f = r?.form || r?.form_oneri || r || {};
    return applyFormFields(prev, { form: f });
}

export function clearDraftStorage() {
    localStorage.removeItem(DRAFT_KEY);
}

export function resetFormState() {
    return {
        form: { ...EMPTY_FORM },
        uploads: { tutanak: [], eksper: [], foto: [], video: [], diger: [] },
        selectedEvrakIds: [],
    };
}

export function deriveWorkflowStep({ toplamDelil, okumaLog, sonuc, kayitId }) {
    if (kayitId || (sonuc && sonuc.guven_skoru != null)) return "rapor";
    if (sonuc?.taraf_a) return "analiz";
    if (okumaLog?.okunan_sayisi > 0) return "okuma";
    if (toplamDelil > 0) return "delil";
    return "delil";
}
